<script>
import { setAccount } from 'actions'
import { getAccount } from 'getters'

export default {
  name: 'mixin-login-required',
  events: {
    'api-error-forbidden': function () {
      // this.$router.go({name: 'login'})
    },
    'api-error-unauthentication': function () {
      this.$router.go({name: 'login'})
    },
  },
  ready() {
    this.apiGet('/api/1.0/accounts/').then(response => {
      return this.setAccount(response.body.data)
    })
  },
  mixins: [
    require('mixin/api-client.vue'),
  ],
  vuex: {
    actions: {
      setAccount: setAccount
    },
    getters: {
      account: getAccount
    },
  },
}
</script>



// WEBPACK FOOTER //
// login-required.vue?3dd08c9a